import type { FaireProductEntity } from "../../entity_types/product";

export const p_d6azr888ch: FaireProductEntity = {
  token: "p_d6azr888ch",
  type: "product",
  name: "Pot Head Cactus Design T-shirt Bella Canvas",
  brandToken: "b_uyrp83b3tq",
  brandName: "Soleinspire",
  imageUrl:
    "https://cdn.faire.com/fastly/95b3273e46a1729e5869b14c4f4ad8cee33f7140c86e18f89584b6d09daab930.webp",
  galleryImageUrls: [],
  priceDollars: 14.55,
  description:
    "The Bella Canvas 3001 tee offers a stylish, fitted look and unmatched comfort with its soft and lightweight fabric. Perfect for everyday wear, this tee combines quality and style seamlessly.\nPot head, cactus shirt, Bella Canvas 3001, plant lover tee, botanical t-shirt, succulent graphic, cactus design, funny plant shirt, casual wear, trendy t-shirt, plant pun, gardening humor, nature lover shirt, unisex tee, soft cotton, lightweight tee, rolled sleeves, modern design, artistic shirt, gardener giftCrafted with high-quality cotton, our Bella Canvas 3001 t-shirts offer exceptional comfort and durability in every size from XS to 3XL.",
  tags: [],
  msrpDollars: 36.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:41.914Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
